import React from "react";
import { Link } from "react-router-dom";
import SteckLogo from "./SteckLogo";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => (
  <footer className="relative z-10" style={{ background: "#040710", borderTop: "1px solid var(--border-soft)" }}>

    <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5 space-y-6">
        <SteckLogo size={70} />
        <div className="font-mono-label text-[var(--slate-dim)] pt-4">
          Steck Aviation, LLC
        </div>
      </div>

      <div className="md:col-span-3 space-y-5">
        <div className="font-mono-label text-[var(--blue-soft)]">Contact</div>
        <ul className="space-y-3 text-sm">
          <li className="flex items-center gap-3 text-[var(--ivory)]">
            <Phone size={14} className="text-[var(--slate)]" /> 903-539-9000
          </li>
          <li className="flex items-center gap-3">
            <Mail size={14} className="text-[var(--slate)]" />
            <a className="editorial-link" href="mailto:contact@steckaviationllc.com">contact@steckaviationllc.com</a>
          </li>
          <li className="flex items-start gap-3 text-[var(--slate)]">
            <MapPin size={14} className="text-[var(--slate)] mt-1 shrink-0" />
            <span>1251 Bromberg Street<br />Mineola, Texas 75773</span>
          </li>
        </ul>
      </div>

      <div className="md:col-span-2 space-y-5">
        <div className="font-mono-label text-[var(--blue-soft)]">Steck</div>
        <ul className="space-y-3 text-sm">
          <li><Link to="/" className="editorial-link">Home</Link></li>
          <li><Link to="/aircraft/beechjet-400a" className="editorial-link">Aircraft</Link></li>
          <li><Link to="/about" className="editorial-link">Management</Link></li>
          <li><Link to="/library" className="editorial-link">Research</Link></li>
          <li><Link to="/operating-outlook" className="editorial-link">Operating Outlook</Link></li>
        </ul>
      </div>

      <div className="md:col-span-2 space-y-5">
        <div className="font-mono-label text-[var(--blue-soft)]">Documents</div>
        <ul className="space-y-3 text-sm">
          <li>
            <a
              className="editorial-link"
              href="/documents/aircraft-management-services.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Management Services
            </a>
          </li>
          <li>
            <a
              className="editorial-link"
              href="/documents/beechjet-400a.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Beechjet 400A
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div style={{ borderTop: "1px solid rgba(255,255,255,0.04)" }}>
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-5">
        <p className="font-mono-label text-[var(--slate-dim)] text-center" style={{ fontSize: 11 }}>
          © 2026 Steck Aviation. All Rights Reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
